import { useState, useEffect } from "react";
import { useTemplate } from "@utils/useTemplate";
import { Template } from "@shared/interfaces/Template";

type FilterType = string;
type TabType = "Mine" | "All";

const useFetchTemplates = (
  activeTab: TabType,
  dropdownFilter: FilterType,
  reportTypeDropdownFilter: FilterType,
  offset = 0,
  limit = 9
) => {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState<number>(0); // For pagination
  const { fetchTemplates } = useTemplate();

  const loadTemplates = async () => {
    setLoading(true);
    try {
      const order = dropdownFilter.toLowerCase(); // "latest" or "oldest"
      const template_type =
        reportTypeDropdownFilter !== "Select Report Type"
          ? reportTypeDropdownFilter
          : undefined;

      const response = await fetchTemplates(activeTab === "Mine", {
        order,
        template_type,
        offset,
        limit,
      });

      setTemplates(response.templates);
      setTotalCount(response.total_count);
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 200);
    }
  };

  useEffect(() => {
    loadTemplates();
  }, [activeTab, dropdownFilter, reportTypeDropdownFilter, offset, limit]);

  return { templates, loading, setTemplates, totalCount, loadTemplates };
};

export default useFetchTemplates;
